<template>
    <el-dialog class="editDialog" :append-to-body="true" width="600px" :visible.sync="showEditDialog"
        :close-on-click-modal="false" :destroy-on-close="true" @close="$emit('update:isShow', false)"
        :show-close="true">

        <div slot="title" class="title">{{ options.course_tag_id ? '编辑' : '新增' }}课程标签</div>

        <div class="content" v-loading="loading">
            <el-form label-width="7em" :model="form" :rules="rules" ref="form">

                <el-form-item :label="'标签名称'" prop="title">
                    <el-input v-model="form.title" :placeholder="`请输入标签名称`"></el-input>
                </el-form-item>

                <el-form-item label="排序" prop="sort">
                    <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
                </el-form-item>

                <el-form-item label="是否启用" prop="status">
                    <el-radio-group v-model="form.status" size="medium">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>


            </el-form>
        </div>

        <div slot="footer" v-show="!loading">
            <el-button type="success" :loading="submitLoading" @click="submit">保存</el-button>
            <el-button type="info" plain @click="$emit('update:isShow', false)">取消</el-button>
        </div>

    </el-dialog>

</template>
<script>
import { initTreeData } from '@/util/common'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import iconJson from '@/styles/icon/iconfont.json'

export default {
    components: {
        Treeselect: () => import('@riophae/vue-treeselect'),
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },
    data() {
        return {
            showEditDialog: false,
            loading: true,
            submitLoading: false,
            form: {},
            listData: [],
            rules: {
                title: [{ required: true, message: '请输入标签名称', trigger: ['blur', 'change'] }],
                sort: [{ required: true, message: '请输入排序', trigger: ['blur', 'change'] }]
            },
        };
    },
    inject: ['refresh'],
    watch: {
        isShow: {
            immediate: true,//初始化立即执行
            handler: function (newVal) {
                this.$nextTick(() => {
                    newVal && this.$refs.form && this.$refs.form.clearValidate();
                });
                this.showEditDialog = newVal;
            }
        },
        options: {
            immediate: true,//初始化立即执行
            deep: true,//对象深度监测
            handler: function (newVal, oldVal) {
                this.init(newVal);
            }
        }
    },
    created() {
        this.$api.course.course_tag({
            method: 'get.course_tag.list',
            course_tag_id: this.options.course_tag_id,
        }).then(res => {
            this.listData = res.data.items;
        }).catch(err => {
            console.log(err);
        });
    },
    methods: {

        init(options) {
            if (options.course_tag_id) {//编辑进来的会有id需要
                this.loading = true;

                this.$api.course.course_tag({
                    course_tag_id: options.course_tag_id,
                    method: 'get.course_tag.item',
                }).then(res => {

                    this.form = res.data;
                    this.loading = false;


                }).catch(err => {
                    this.loading = false;
                    console.log(err);
                })

            } else {
                this.form = {
                    parent_id: 0,
                    status: 1,
                };
                this.loading = false;
            };
        },
        submit() {
            this.$refs.form.validate((valid, obj) => {
                if (valid) {

                    this.submitLoading = true;
                    this.$api.course.course_tag(this.form.combination({
                        module: 'admin',
                        method: this.form.course_tag_id ? 'set.course_tag.item' : 'add.course_tag.item',
                    })).then(res => {
                        this.submitLoading = false;
                        this.refresh(1);
                        this.$message.success("操作成功！");

                    }).catch(err => {
                        this.submitLoading = false;
                        console.log(err);
                    })
                } else {
                    this.scrollView(obj)
                };
            });
        },
    },
};
</script>
